<template>
  <v-card class="com-pc-card rw-number">
    <v-col class="com-pc-card-header rw-header">
      <span class="com-pc-card-title">発表号数</span>
    </v-col>
    <v-col class="white">
      <span v-for="(item, index) in selectedRwDetail.rwBase" :key="index">
        <v-btn
          class="btn_on mr-1 ml-1"
          v-bind:class="{
            btn_on: selectedAnnIdx == index,
            btn_off: selectedAnnIdx != index,
          }"
          outlined
          x-small
          fab
          color="indigo"
          @click="selectAnnIdx(index)"
          >{{ item.annNo }}</v-btn
        >
      </span>
    </v-col>
  </v-card>
</template>

<script>
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "rw-number",

  computed: {
    /**
     * 選択中河川予警報発表番号
     */
    selectedAnnNo: {
      get() {
        return this.$store.state.RiverWarn.selectedAnnNo;
      },
    },
    /**
     * 選択中予警報発表インデックス
     */
    selectedAnnIdx: {
      get() {
        return this.$store.state.RiverWarn.selectedAnnIdx;
      },
    },
    /**
     * 選択中河川予警報情報
     */
    selectedRwDetail: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail;
      },
    },
    /** 設定情報 */
    config: {
      get() {
        return this.$store.state.app.config;
      },
    },
    /**
     * 選択中河川予警報詳細
     */
    selectedRwDetailRw: {
      get() {
        return this.$store.state.RiverWarn.selectedRwDetail.rwBase[
          this.$store.state.RiverWarn.selectedAnnIdx
        ];
      },
    },
  },
  methods: {
    // /** 発表番号選択時 */
    // selectAnnNo(annNo) {
    //   this.$log.debug("[Riverwarn] selectAnnNo(" + annNo + ")");
    //   this.$store.commit("RiverWarn/setSelectedAnnNo", annNo);
    // },
    /** 発表番号選択時 */
    selectAnnIdx(annIdx) {
      this.$log.debug("[Riverwarn] selectAnnIdx(" + annIdx + ")");
      this.$store.commit("RiverWarn/setSelectedAnnIdx", annIdx);
    },
  },
  watch: {
    selectedRwDetailRw() {
      // アクセスログ出力
      let name = "";
      if (this.$store.state.RiverWarn.selectedWarnType == 10) name = "fdfore";
      if (this.$store.state.RiverWarn.selectedWarnType == 11) name = "wlinfo";
      if (this.$store.state.RiverWarn.selectedWarnType == 20) name = "fdcntl";
      if (this.$store.state.RiverWarn.selectedWarnType == 30)
        name = "damdischa";
      PageLog.log({
        page_log: name,
        flood_cd: this.$store.state.RiverWarn.selectedWarnReq.cd,
        flood_no: this.selectedRwDetailRw.annNo,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.rw-number {
  width: 100%;

  .rw-header {
    display: flex;
    align-items: center;
  }

  .btn_on {
    background-color: lightblue;
  }
  .btn_off {
    background-color: white;
  }

  .rw-number-line {
    border-bottom: solid lightgray 1px;
  }
}
</style>
